import moment from 'moment';
import { getPeriodWeek } from 'View/schedule-generate/helper/getPeriodDay';

const getGenerateScheduleResponse = (response, hostsInRulesets, formData) => {
  if (!response?.data) {
    return {
      metadata: response.metadata,
      accounts: [],
    };
  }

  const paydayDate = [];
  const peakDayDate = [];
  const doubleDate = [];

  const toMinutes = (t) => {
    const [h, m] = (t || '00:00:00').split(':').map(Number);
    return h * 60 + (m || 0);
  };

  const anchorYearMonth = response?.yearMonth || formData?.yearMonth;
  const anchorYear = parseInt(anchorYearMonth?.slice(0, 4));
  const anchorMonth = parseInt(anchorYearMonth?.slice(5, 7));
  const nextMonth = anchorMonth === 12 ? 1 : anchorMonth + 1;
  const nextYear = anchorMonth === 12 ? anchorYear + 1 : anchorYear;

  const isInPeriod = (entryYear, entryMonth, entryDay) =>
    (entryYear === anchorYear && entryMonth === anchorMonth && entryDay >= 16) ||
    (entryYear === nextYear && entryMonth === nextMonth && entryDay <= 15);

  const accounts = response?.data?.map((account) => {
    const datas = [];
    account.data.map((entry) => {
      const entryYear = parseInt(entry?.date?.slice(0, 4));
      const entryMonth = parseInt(entry?.date?.slice(5, 7));
      const entryDay = parseInt(entry?.date?.slice(8, 10));

      if (!isInPeriod(entryYear, entryMonth, entryDay)) {
        return entry;
      }

      const parseIntDate = parseInt(entry.dayOfMonth);

      if (entry?.isPeakDay && !peakDayDate.includes(parseIntDate)) peakDayDate.push(parseIntDate);
      if (entry?.isPayday && !paydayDate.includes(parseIntDate)) paydayDate.push(parseIntDate);
      if (entry?.isDoubleDate && !doubleDate.includes(parseIntDate)) doubleDate.push(parseIntDate);

      const dayBase = moment(entry.date).startOf('day');

      const startMin = toMinutes(entry?.subShiftStartTime);
      let endMin = toMinutes(entry?.subShiftEndTime);
      if (endMin === 0 && startMin > 0) endMin = 1440;
      if (endMin <= startMin) endMin += 1440;

      entry.hosts?.map((host) => {
        for (let m = startMin; m < endMin; m += 120) {
          const slotStart = dayBase.clone().add(m, 'minutes');
          const slotEnd = dayBase.clone().add(m + 120, 'minutes');
          const slotStartHour = slotStart.hour();
          const slotEndHour = slotEnd.hour();
          const slotStartDate = slotStart.format('YYYY-MM-DD');
          const slotEndDate = slotEnd.format('YYYY-MM-DD');
          const slotDayOfMonth = slotStart.date();
          const hour = slotStartHour;

          if (hour % 2 !== 0) continue;

          const week = getPeriodWeek(slotDayOfMonth, anchorYearMonth);

          const masterHost = hostsInRulesets.find((item) => item.id === host.userId);
          const scheduleMap = {
            ...host,
            location: [slotDayOfMonth, hour],
            accountId: account?.accountId,
            studioId: account?.studioId,
            bgColor: masterHost?.bgColor || '#D7EECA',
            subShiftStartTime: new Date(`${slotStartDate} ${String(slotStartHour).padStart(2, '0')}:00:00`),
            subShiftEndTime: new Date(`${slotEndDate} ${String(slotEndHour).padStart(2, '0')}:00:00`),
          };

          const weekIndex = datas.findIndex((data) => data.week === week);
          if (weekIndex === -1) {
            datas.push({ week, schedules: [scheduleMap] });
          } else {
            datas[weekIndex] = {
              ...datas[weekIndex],
              schedules: [...datas[weekIndex].schedules, scheduleMap],
            };
          }
        }
        return host;
      });
      return entry;
    });
    return {
      type: account?.accountId?.join(','),
      label: account?.name,
      accountId: account?.accountId,
      studioId: account?.studioId,
      name: account?.name,
      studioName: account?.studioName,
      datas,
    };
  });

  const result = {
    metadata: {
      ...response?.metadata,
      doubleDate,
      peakDayDate,
      paydayDate,
      generatedScheduleId: response?.generatedScheduleId,
      agency: response?.agency?.agencyNormalStart ? response?.agency : null,
      yearMonth: response?.yearMonth,
    },
    accounts,
  };

  return result;
};

export default getGenerateScheduleResponse;
